export const getSubscriptionPlanById = (state) => (id) => state.payment.subscriptionPlans.find((plan) => plan.id === id);
